import "../scss/index.scss"
import $ from "jquery"
window.$ = $;

import "frameworks/foundation_init.js"

import "../../cms_plugins/expert_search/js/index.js"
import "../../cms_plugins/main_navigation/js/index.js"
import "../../cms_plugins/search_field/js/index.js"
import "../../cms_plugins/zitat_display/js/index.js"
import "../../cms_plugins/footer/js/index.js"
import "../../cms_plugins/startseite_auszug/js/index.js"




// WEBPACK FOOTER //
// ./frontend/js/index.js